import type { ReactNode } from "react";
import { PortalAuthConfigContext, type PortalAuthConfig } from "./portalAuthConfig";
import { PortalSessionContext } from "./PortalSessionContext";
import { usePortalSessionStore } from "./portalSessionStorage";

interface PortalAuthProviderProps {
  config: PortalAuthConfig;
  children: ReactNode;
}

/**
 * Root provider of a password-plus-OTP portal: publishes the portal's
 * `PortalAuthConfig` and the session token stored under `config.storageKey`,
 * with its setter and `clear`, to the whole app. Routes and `usePortalApi`
 * read the session through `usePortalSession`, so the token lives in one place
 * and a 401 that clears it reaches every consumer.
 */
export function PortalAuthProvider({ config, children }: PortalAuthProviderProps): ReactNode {
  const store = usePortalSessionStore(config.storageKey);
  return (
    <PortalAuthConfigContext.Provider value={config}>
      <PortalSessionContext.Provider value={store}>{children}</PortalSessionContext.Provider>
    </PortalAuthConfigContext.Provider>
  );
}
